import { useQuery } from "@tanstack/react-query";
import { getIsMaintenance } from "../api/getIsMaintenance";

export const getIsMaintenanceQueryKey = ["maintenance"];

export const getUseIsMaintenanceQueryOptions = [
  getIsMaintenanceQueryKey,
  getIsMaintenance,
] as const;

export const useIsMaintenanceQuery = () =>
  useQuery<boolean>(...getUseIsMaintenanceQueryOptions);
